import React from "react";
import { motion } from "framer-motion";

export default function PageHero({ overline, title, subtitle, badge }) {
  return (
    <section className="relative pt-36 pb-14 md:pt-44 md:pb-20">
      <div className="relative z-10 max-w-[1300px] mx-auto px-5 md:px-8">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.2, 0.8, 0.2, 1] }}>
          {badge ? <span className="pill-badge mb-6"><span className="dot" /> {badge}</span> : <span className="overline mb-5 block">{overline}</span>}
          <h1 className="display-mega text-5xl md:text-7xl lg:text-8xl max-w-4xl">{title}</h1>
          {subtitle && <p className="text-neutral-500 text-lg mt-6 max-w-2xl leading-relaxed">{subtitle}</p>}
        </motion.div>
      </div>
    </section>
  );
}
